const bedc = [
	'bedc:franchise:create',
	//
	'bedc:franchise:read:{franchiseId}',
	//
	'bedc:franchise:update:{franchiseId}',
	//
	'bedc:franchise:delete:{franchiseId}',
	//
	'bedc:franchise:lookup',
	'bedc:franchise:list',
	'bedc:franchise:search',
] as const;

export default [...bedc] as const;
